import { Platform } from "../../Platform";
import { PageObserverEvents } from "../../../../utils/PageObserver";
import {AdUnitStatus, FloatingType, PlayerType, QueueManagerStatus} from "../../../../utils/const";

export class InpageBase extends Platform {
	constructor(cfg) {
		super(cfg);
		
		this.isEventsSubscribed = false;
	}
	
	getContainerWidth = (container) => {
		if (container.clientWidth >= 240) return container.clientWidth;
		if (container === document.body) return 240;
		
		// const maxWidth = parseInt(container.style.maxWidth);
		// if (maxWidth) return maxWidth;

		const maxWidth = container.style.maxWidth;
		if (maxWidth) {
			if (maxWidth.includes('px')) return parseInt(maxWidth);
			// if (maxWidth.includes('%')) return container.clientWidth;
		}

		// const maxHeight = parseInt(container.style.maxHeight);
		// if (maxHeight) return maxHeight * 16 / 9;

		const maxHeight = container.style.maxHeight;
		if (maxHeight) {
			if (maxHeight.includes('px')) return parseInt(maxHeight) * 16 / 9;
			// if (maxHeight.includes('%')) return container.clientHeight * 16 / 9;
		}


		return this.getContainerWidth(container.parentElement);
	}

	getContainerWithLimitedDimension = (container, dimension) => {
		const dimensionValue = container.style[dimension] || window.getComputedStyle(container).getPropertyValue(dimension);
		const maxDimension = dimensionValue.includes('px') ? parseInt(dimensionValue) : null;
		if (maxDimension) {
			return maxDimension;
		} else {
			if (!container.parentElement) return null;
			return this.getContainerWithLimitedDimension(container.parentElement, dimension);
		}
	}

	_parseCSSVars = () => {
		let float = {};
		const styles = this.config.styles.inpage;
		let containerWidth = this.getContainerWidth(this.container);

		const limitedHeight = this.getContainerWithLimitedDimension(this.container, 'max-height');
		const limitedWidth = this.getContainerWithLimitedDimension(this.container, 'max-width');

		if (limitedHeight !== null) containerWidth = Math.min(containerWidth, (limitedHeight * 16 / 9));
		if (limitedWidth !== null) containerWidth = Math.min(containerWidth, limitedWidth);

		const width = containerWidth > styles.maxWidth ? styles.maxWidth : containerWidth;
		
		const floatStyles = this.config.styles.slider;
		if (floatStyles) {
			float = {
				width:`${floatStyles.maxWidth}px`,
				height: `${floatStyles.maxWidth / 16 * 9}px`,
				position: {
					right: !isNaN(floatStyles.position.right) ? `${floatStyles.position.right}px` : 'auto',
					left: !isNaN(floatStyles.position.left) ? `${floatStyles.position.left}px` : 'auto',
					top: !isNaN(floatStyles.position.top) ? `${floatStyles.position.top}px` : 'auto',
					bottom: !isNaN(floatStyles.position.bottom) ? `${floatStyles.position.bottom}px` : 'auto',
				},
				close: {
					display: floatStyles.close.enable ? 'flex' : 'none',
					countdownDisplay: floatStyles.close.showCountdown ? 'flex' : 'none',
					
					left: 'auto',
					right: 'auto',
					[floatStyles.close.position]: '10px',
					
					size: `${floatStyles.close.size}px`,
					clickArea: `${floatStyles.close.clickArea}px`,
				},
			}
		}

		return ({
			width:`${width}px`,
			height: `${width / 16 * 9}px`,
			background: styles.background || '#fff',
			top: `${styles.top || 0}px`,
			bottom: `${styles.bottom || 0}px`,
			float,
			zone: this.config.zone,
			zIndex: this.config.styles.zIndex,
		});
	}
	
	subscribeEvents = () => {
		this.pageObserver.subscribe(PageObserverEvents.onPlayerInView, ({ inView }) => {
			if (inView) {
				if (this.queueManager.status === QueueManagerStatus.WAIT_FOR_VIEW) {
					this.queueManager.status = QueueManagerStatus.READY_TO_PLAY;
				}
				
				if (this.queueManager.status === QueueManagerStatus.PLAYING && this.config.type === PlayerType.INPAGE) { // TODO: move all inpage stuff to Inpage.js
					const { activeUnit } = this.queueManager;
					if (activeUnit && activeUnit.status === AdUnitStatus.PAUSED && activeUnit.resume) {
						activeUnit.resume();
					}
				}
			} else {
				if (this.queueManager.status === QueueManagerStatus.PLAYING && this.config.type === PlayerType.INPAGE) {
					const { activeUnit } = this.queueManager;
					if (activeUnit && activeUnit.status === AdUnitStatus.PLAYING && activeUnit.pause) {
						activeUnit.pause();
					}
				}
			}
		});
		
		this.isEventsSubscribed = true;
	}

	_checkPlayerStartRequirements = () => {
		if (!this.isEventsSubscribed) this.subscribeEvents();

		this.queueManager.status = (this.pageObserver.playerInView || this.config.floating_mode === FloatingType.ALWAYS) ? QueueManagerStatus.READY_TO_PLAY : QueueManagerStatus.WAIT_FOR_VIEW;
	}
}